

export const NW_TRUE  = 1;
export const NW_FALSE = 0;